import { searchGasStationCodeList } from '@/api/GasStation/GasStationManagement/GasStationList.js'
import { searchCodeList } from '@/api/GasStation/index.js'
import { searchGasTankCodeList } from '@/api/GasStation/GasStationManagement/GasTankConfig.js'
import { levelParams } from '@/api/member/member_level'

const state = {
  /** 油站选项列表 */
  stationCodeList: [],
  /** 油罐选项列表 */
  gasTankCodeList: [],
  /** 会员等级详情选项 */
  LevelParams: [],
  /** 启用、停用状态 */
  statusOption: [
    {
      label: '正常',
      value: 0
    },
    {
      label: '禁用',
      value: 1
    }
  ],
  /** 启用、停用状态 */
  stateOption: [
    {
      label: '启用',
      value: 0
    },
    {
      label: '停用',
      value: 1
    }
  ],
  /** 码表 */
  codeList: {
    /** 油品类型 */
    oilType: [],
    /** 油品标号 */
    oilNum: [],
    /** 油品标号 */
    oil_tank: [],
    /** 油罐计量单位 */
    oilTankUnit: [],
    /** 每月天数 */
    day: [],
    /** 油品列表 */
    oils: [],
    menu: 'GasTankConfig'
  }
}

const mutations = {
  setStationCodeList (state, list) {
    state.stationCodeList = list
  },
  setGasTankCodeList (state, list) {
    state.gasTankCodeList = list
  },
  setLevelParamsList (state, list) {
    state.LevelParams = list
  },
  setCodeList: (state, { unit = [], name = [], oil_tank = [], type = [], day = [], oils = [] }) => {
    state.codeList.oilType = name
    state.codeList.oilNum = type
    state.codeList.oil_tank = oil_tank
    state.codeList.oilTankUnit = unit
    state.codeList.day = day
    state.codeList.oils = oils
  }
}

const actions = {
  async initStationCodeList ({ commit, state }) {
    try {
      const res = await searchGasStationCodeList({ page: 1, limit: 20 })
      if (res.code === 20000) {
        commit('setStationCodeList', res.data.data)
      }
    } catch (error) {
      console.log(error)
    }
  },
  async initGasTankCodeList ({ commit, state }) {
    try {
      const res = await searchGasTankCodeList({ page: 1, limit: 20, station_id: '' })
      if (res.code === 20000) {
        commit('setGasTankCodeList', res.data.data)
      }
    } catch (error) {
      console.log(error)
    }
  },
  async initCodeList ({ commit, state }) {
    try {
      const res = await searchCodeList()
      if (res.code === 20000) {
        commit('setCodeList', res.data || {})
      }
    } catch (error) {
      console.log(error)
    }
  },
  async initLevelParams ({ commit, state }) {
    try {
      const res = await levelParams()
      if (res.code === 20000) {
        commit('setLevelParamsList', res.data.goods_type || {})
      }
    } catch (error) {
      console.log(error)
    }
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
